import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { capitalize } from 'lodash'

import ProfileForm from '../leevo_ui/ProfileForm/ProfileForm'
import LoadingSpinner from '../leevo_ui/LoadingSpinner/LoadingSpinner'
import ApplicationLayout from '../leevo_ui/ApplicationLayout/ApplicationLayout'
import { requestCreator } from '../../utilities/requests'
import useAuth from '../../utilities/hooks/useAuth'
import toast from '../../utilities/toast'

const { get: getUser, put: saveUser, cancel: cancelUserRequests } = requestCreator()

function ProfileFeature() {
  const [fields, setFields] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const auth = useAuth()

  useEffect(() => {
    getUser(`/api/users/${auth.currentUser.id}`)
      .then((data) => {
        setFields(data)
        setIsLoading(false)
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          console.error('Failed to load user data:', error)
          toast.error('Failed to load your profile. Please try again.')
        }
      })

    return cancelUserRequests
  }, [auth.currentUser])

  async function onSubmit(values) {
    try {
      await saveUser(`/api/users/${auth.currentUser.id}`, { user: values })

      toast.success('Your changes have been saved successfully!')

      const updatedUser = await getUser(`/api/users/${auth.currentUser.id}`)
      setFields(updatedUser)

      return Promise.resolve()
    } catch (err) {
      let errorMessage = 'We were unable to save your changes.'

      if (err.response?.data?.errors) {
        errorMessage = Object.entries(err.response.data.errors)
          .reduce((fullString, error) => (fullString += `${capitalize(error.join(' '))}. `), '')
          .trim()
      }

      toast.error(errorMessage)

      return Promise.reject(err)
    }
  }

  return (
    <ApplicationLayout>
      {isLoading ? (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
          <LoadingSpinner size="1/5" className="flex items-center justify-center" />
        </div>
      ) : (
        <ProfileForm {...fields} id={auth.currentUser.id} onSubmit={onSubmit} />
      )}
    </ApplicationLayout>
  )
}

export default ProfileFeature
